import React from 'react';

import Button from '../Form/Button/Button';

interface Props {
    primary: boolean;
    onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
}

const LoginOverlayButton: React.FunctionComponent<Props> = (props) => {
    const triggerClick = (event: React.FormEvent<HTMLButtonElement>) => {
        window.Carbon('dialogues')['carbon-dialog__login-default'].show();

        // invoke optional additional callback function
        if (typeof props.onClick === 'function') {
            props.onClick(event);
        }
    };

    return (
        <Button primary={props.primary} type="button" onClick={triggerClick} className="button--color-petrol">
            Anmelden
        </Button>
    );
};

export default LoginOverlayButton;
